import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const AlertIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = disabled
        ? colors.neutrals.borderAlpha
        : type === 'utility'
            ? colors.status.fail.alpha
            : getIconColor(colors, type, disabled);
    const strokeColor = type === 'utility' ? colors.neutrals.background : color;
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 33 28", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: color, strokeWidth: "2.4" },
            React.createElement("path", { d: "M2.4 23a2.4 2.4 0 002 3.6h25a2.4 2.4 0 002-3.6L18.8 3a2.4 2.4 0 00-4 0L2.4 23z", fill: type === 'utility' ? color : 'none' }),
            React.createElement("path", { d: "M16.9 17.3V10m0 12v-1", fillRule: "nonzero", stroke: strokeColor, strokeLinecap: "round" }))));
};
export default AlertIcon;
//# sourceMappingURL=index.js.map